export default {"src":"/_next/static/media/copy-icon.992d228b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};